export default __webpack_public_path__ + "static/media/lock-ic.774e5665.svg";